@if (viewModel$ | async; as viewModel) {
  <nav class="flex items-stretch" role="menu">
    @for (route of viewModel.routes; track route.path) {
      <a
        [routerLink]="route.path"
        routerLinkActive="link--active"
        class="link"
        role="menuitem"
        >
        <svg class="w-[15px] h-[15px]">
          <use [attr.xlink:href]="route.icon"></use>
        </svg>
        {{route.name}}
      </a>
    }
  </nav>

  <a
    [routerLink]="viewModel.notificationsPath"
    class="ml-6 inline-flex items-center text-[#aab6c4] hover:text-white transition-colors"
    aria-label="Notifications"
    data-testid="notifications-link"
  >
    <span class="relative flex items-center">
      <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24">
        <path d="M6 9a6 6 0 0112 0c0 5 2 6 2 6H4s2-1 2-6z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" />
        <path d="M10 19a2 2 0 004 0" stroke="currentColor" stroke-width="1.7" />
      </svg>
      @if (activeRequestCount$ | async; as count) {
        @if (count > 0) {
          <span data-testid="notifications-badge" class="absolute -top-1.5 -right-[7px] bg-[color:var(--em-danger)] text-white text-[10px] font-bold rounded-[9px] min-w-4 h-4 px-1 flex items-center justify-center">
            {{ count > 99 ? '99+' : count }}
          </span>
        }
      }
    </span>
  </a>
}

<em-dashboard-header-user-dropdown/>
